// Pill tabs for a product with more than one size chart, rendered by
// snippets/size-chart-tabs.liquid inside the Size Guide drawer.
//
// A custom element rather than a DOMContentLoaded script: content-drawer.js
// clones its <template> into the panel on every open, and custom elements
// upgrade when they are inserted — so connectedCallback runs on each open,
// where a page-load querySelectorAll would never see these nodes at all.
//
// The active look is driven entirely by aria-selected (see base.css), so
// selecting a tab is two attribute writes and no class bookkeeping.

class SizeChartTabs extends HTMLElement {
  connectedCallback() {
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.addEventListener("click", this.onClick);
    this.addEventListener("keydown", this.onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
    this.removeEventListener("keydown", this.onKeydown);
  }

  get tabs() {
    return [...this.querySelectorAll("[data-size-chart-tab]")];
  }

  onClick(event) {
    const tab = event.target.closest("[data-size-chart-tab]");
    if (!tab) return;
    this.select(tab.dataset.sizeChartTab);
  }

  onKeydown(event) {
    const tab = event.target.closest("[data-size-chart-tab]");
    if (!tab) return;

    const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
    if (!step) return;

    const { tabs } = this;
    const next = tabs[(tabs.indexOf(tab) + step + tabs.length) % tabs.length];
    if (!next) return;

    event.preventDefault();
    this.select(next.dataset.sizeChartTab);
    next.focus();
  }

  select(index) {
    for (const tab of this.tabs) {
      tab.setAttribute("aria-selected", String(tab.dataset.sizeChartTab === index));
    }

    for (const panel of this.querySelectorAll("[data-size-chart-panel]")) {
      panel.hidden = panel.dataset.sizeChartPanel !== index;
    }
  }
}

if (!customElements.get("size-chart-tabs")) {
  customElements.define("size-chart-tabs", SizeChartTabs);
}
